<script setup lang="ts">
    defineProps({
        title: {
            type: String,
            required: false,
        },
        description: {
            type: String,
            required: false,
        },
    })
</script>

<template>
    <v-card flat class="card-border pb-2 mb-5">
        <v-card-title class="title-border" v-if="title">
            {{ title }}
        </v-card-title>
        <div>
            <slot />
        </div>
    </v-card>
</template>

<style scoped>
    .card-border {
    border: 1px solid rgba(0, 0, 0, 0.18);

}
.title-border {
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    font-size: 18px;
    font-weight: 500;
}
</style>
